﻿
var yetVisited = "";

$(document).ready(function () {
    yetVisited = getCookie("newsletterSignUp");
    if (yetVisited != "") {
        document.getElementById("newsletterSignUp").style.display = "none";
        document.getElementById("newsletterThankYou").style.display = "";
    }
});

function newsletterSignUp() {
    var mailvalue = document.getElementById('mastersignup').value.trim();
    var recaptchavalue = document.getElementById('hidNotRobot').value.trim();

    if (mailvalue == "" || mailvalue == "Email Address") {
        alert("Please enter email address.");
        document.getElementById('hidNotRobot').value = false;
        document.getElementById('chkNotRobot').checked = false;
    }
    else if (recaptchavalue.toLowerCase() != "true") {
        alert('Not a valid reCAPTCHA. Please re-submit.');
        document.getElementById('hidNotRobot').value = false;
        document.getElementById('chkNotRobot').checked = false;
    }
    else if (mailvalue != "") {
        var rx = new RegExp("^[\\w\.=-]+@[\\w\\.-]+\\.[a-zA-Z]{2,4}$");
        if (!rx.test(mailvalue)) {
            alert("Please enter a valid email address.");
            document.getElementById('hidNotRobot').value = false;
            document.getElementById('chkNotRobot').checked = false;
        }
        else {
            document.getElementById("nsSubmit").style.display = "none";
            document.getElementById("nsProcessing").style.display = "";
            $.ajax({
                type: "POST",
                url: "AjaxNewsletterSignup.aspx",
                data: { email: mailvalue, recaptcha: recaptchavalue, type: "NewsletterTemplate" },
                error: function () {
                    alert('Error! Please re-submit.');
                    document.getElementById("newsletterThankYou").style.display = "none";
                    document.getElementById("nsProcessing").style.display = "none";
                    document.getElementById("nsSubmit").style.display = "";
                    document.getElementById("newsletterSignUp").style.display = "";
                    document.getElementById('hidNotRobot').value = false;
                    document.getElementById('chkNotRobot').checked = false;
                },
                success: function (msg) {
                    if ($.trim(msg) == 'error' || $.trim(msg) == 'error1' || $.trim(msg) == 'error2') {
                        alert('Error Signing Up. Please re-submit.');
                        document.getElementById("newsletterThankYou").style.display = "none";
                        document.getElementById("nsProcessing").style.display = "none";
                        document.getElementById("nsSubmit").style.display = "";
                        document.getElementById("newsletterSignUp").style.display = "";
                        document.getElementById('hidNotRobot').value = false;
                        document.getElementById('chkNotRobot').checked = false;
                    }
                    else if ($.trim(msg) == 'errRecaptcha') {
                        alert('Not a valid reCAPTCHA. Please re-submit.');
                        document.getElementById("newsletterThankYou").style.display = "none";
                        document.getElementById("nsProcessing").style.display = "none";
                        document.getElementById("nsSubmit").style.display = "";
                        document.getElementById("newsletterSignUp").style.display = "";
                        document.getElementById('hidNotRobot').value = false;
                        document.getElementById('chkNotRobot').checked = false;
                    }
                    else {
                        if (!yetVisited) {
                            setCookie("newsletterSignUp", "yes", 30);
                        }
                        document.getElementById("newsletterSignUp").style.display = "none";
                        document.getElementById("newsletterThankYou").style.display = "";
                    }
                }
            });
        }
    }
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

